import Spinner from './Spinner'

interface Props {
  /** Mensagem opcional abaixo do spinner */
  message?: string
  /** Se true, ocupa 100% da tela (para Suspense fallback). Default true. */
  fullscreen?: boolean
}

/** Indicador de carregamento centralizado — use como fallback do Suspense ou enquanto hooks carregam. */
export default function PageLoader({ message, fullscreen = true }: Props) {
  return (
    <div
      style={{
        width: '100%',
        minHeight: fullscreen ? '60vh' : 120,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        color: 'var(--text3)',
      }}
    >
      <Spinner size={28} color="var(--accent)" />
      {message && <div style={{ fontSize: 13, color: 'var(--text3)' }}>{message}</div>}
    </div>
  )
}
